import { createContext, useContext } from 'react';

import Store from 'mobx/store';

export const store = new Store();

const StoreContext = createContext(store);

export const ProviderMobx = StoreContext.Provider;

export const useStore = () => useContext(StoreContext);
